import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { columns } from '../../../../app/common/modal/NoticeProductItemListModal/columns';
import './NoticeProductDetailItemInfo.scss';

const NoticeProductDetailItemInfo = (props) => {
  const { itemListInfo, getList, getProductSubCategoryList } = props;
  const { list, pagination, summary } = itemListInfo;

  return (
    <Panel className="notice-product-detail-item-info" name="notice-product-detail-item-info">
      <div className="panel-header">
        <div className="title">상품 정보</div>
      </div>

      <div className="panel-body">
        <TableWithSummary
          className={'notice-product-detail-item-info-table'}
          data={list}
          totalCnt={summary.totalCnt}
          isStriped={true}
          showPagination
          emptyText="공지사항에 등록된 상품이 없습니다."
          maxHeight={400}
          pagination={pagination}
          getList={getList}
          columns={(utils) =>
            columns({
              ...utils,
              getProductSubCategoryList,
            })
          }
        />
      </div>
    </Panel>
  );
};

export default NoticeProductDetailItemInfo;
